







































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { envCongif } from '@/shared/env.config';
import { MswAppTitle } from '@/shared/msw-app-title';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';

const cssPrefix = 'catp-protection';

@Component({
  components: {
    SwIcon,
    MswAppTitle,
  },
})
export default class CatpProtection extends SwExtendedVue {
  cssPrefix = cssPrefix;
  environment: string = envCongif.env !== 'PROD' ? envCongif.env : '';
  messageToDisplay: String = '';
  frameUrl: String = '';
  showTitle: boolean = false;

  get queryParams() {
    return this.$route.query;
  }

  mounted() {
    const { id, sn, key } = this.queryParams;
    const payload: any = {
      sn,
      key,
      taskid: id,
    };
    this.$store
      .dispatch('CatpProtectionStoreModule/catpProtectionRedirect', payload)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp?.operationStatus === 'OK' && resp?.msgCode === 'MSWAPP:CATPPROTECTFAILURE') {
          this.messageToDisplay = resp?.msgDesc;
        } else {
          this.frameUrl = resp?.content?.frameUrl;
        }
      });
  }

  created() {
    const { mode } = this.queryParams;
    mode === 'APP' ? (this.showTitle = true) : (this.showTitle = false);
  }
}
